import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {SummaryFieldModule} from "../../summary-field/summary-field.module";
import {DatetimeLabelModule} from "../datetime-label/datetime-label.module";
import {DatetimeSummaryFieldComponent} from "./datetime-summary-field.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        DatetimeLabelModule,
        SummaryFieldModule,
    ],
    declarations: [
        DatetimeSummaryFieldComponent,
    ],
    exports: [
        DatetimeSummaryFieldComponent,
    ],
})
export class DatetimeSummaryFieldModule {
}